import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Button,
  Table,
  Modal,
  Container,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  FormGroup,
  Label,
  ButtonGroup,
} from "reactstrap";

const RegComp = () => {
  const [modal, setModal] = useState(false);
  const [claseEditar, setClaseEditar] = useState(null);
  const [nuevaMateria, setNuevaMateria] = useState("");
  const [nuevaNota, setNuevaNota] = useState("");
  const [nuevoHora, setNuevoHora] = useState("");
  const [agregandoClase, setAgregandoClase] = useState(false);
  const [diaParaAgregar, setDiaParaAgregar] = useState("lunes");
  const [claseIdEditar, setClaseIdEditar] = useState(null);

  ///link api php
  const baseUrlB = "https://bqef-bo.com/api/B/apiBecario.php";

  // Estado para filtros
  const [anioSeleccionado, setAnioSeleccionado] = useState("PRIMER"); // ejemplo
  const [diaSeleccionado, setDiaSeleccionado] = useState("lunes"); // ejemplo

  // Estado para horario
  const [horario, setHorario] = useState([]);

  // Cargar datos desde API con axios
  const peticionGetHorario = async () => {
    try {
      const BecId = sessionStorage.getItem("iduser");
      const params = {
        id: BecId,
        anio: anioSeleccionado,
        dia: diaSeleccionado,
      };
      const res = await axios.get(`${baseUrlB}?action=getHorario`, { params });
      setHorario(res.data.InfoHorario || []);
      // console.log("Datos Obtenidos:", res.data);
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Error al obtener los datos del horario", "error");
    }
  };
  // useEffect para actualizar horario cuando cambian filtros
  useEffect(() => {
    // Función para hacer polling
    const fetchInterval = setInterval(() => {
      peticionGetHorario();
    }, 5000); // cada 10 segundos

    // Ejecutar inmediatamente al inicio
    peticionGetHorario();

    // Limpiar intervalo cuando el componente se desmonta
    return () => clearInterval(fetchInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [anioSeleccionado, diaSeleccionado]); // Si estos cambian, se vuelve a hacer el polling

  // Cambiar año
  const handleAnioChange = (año) => {
    setAnioSeleccionado(año);
  };

  // Cambiar día
  const handleDiaChange = (dia) => {
    // console.log("Cambió día a:", dia);
    setDiaSeleccionado(dia);
  };

  // Editar clase
  const handleEditarClase = (clase, index) => {
    setClaseEditar({ ...clase, index });
    setNuevaMateria(clase.materia);
    setNuevoHora(clase.hora);
    setNuevaNota(clase.nota);
    setModal(true);
  };

  // Agregar clase
  const handleAgregarClase = () => {
    setAgregandoClase(true);
    setNuevaMateria("");
    setNuevoHora("");
    setDiaParaAgregar("lunes");
    setModal(true);
  };

  // Guardar cambios en clase editada
  const handleGuardarClase = async () => {
    const idBeca = sessionStorage.getItem("iduser");
    const idClase = claseEditar.id; // Asegúrate que `claseEditar` tiene `id`

    if (!idBeca || !idClase) {
      Swal.fire("Error", "ID de beca o clase no válido", "error");
      return;
    }

    const data = {
      id_bec: idBeca,
      id: idClase, // pasa el ID de la clase
      anio: anioSeleccionado,
      dia: diaSeleccionado,
      hora: nuevoHora,
      materia: nuevaMateria,
      nota: nuevaNota,
    };

    try {
      const res = await axios.post(`${baseUrlB}?action=editClase`, data, {
        headers: { "Content-Type": "application/json" },
      });

      if (res.data.success) {
        Swal.fire("Actualizado", "Clase modificada correctamente", "success");

        // Actualiza la lista local
        const nuevoHorario = { ...horario };
        if (
          nuevoHorario[anioSeleccionado] &&
          nuevoHorario[anioSeleccionado][diaSeleccionado] &&
          Array.isArray(nuevoHorario[anioSeleccionado][diaSeleccionado])
        ) {
          nuevoHorario[anioSeleccionado][diaSeleccionado][claseEditar.index] = {
            ...claseEditar,
            hora: nuevoHora,
            materia: nuevaMateria,
            nota: nuevaNota,
          };
          setHorario(nuevoHorario);
        }
        setModal(false);
        peticionGetHorario();
      } else {
        Swal.fire("Error", "No se pudo editar la clase", "error");
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Error al editar la clase", "error");
    }
  };

  // Agregar nueva clase
  const handleGuardarNuevaClase = async () => {
    const idBec = sessionStorage.getItem("iduser");
    const data = {
      id_bec: idBec,
      anio: anioSeleccionado,
      dia: diaParaAgregar,
      hora: nuevoHora,
      materia: nuevaMateria,
    };

    try {
      const res = await axios.post(`${baseUrlB}?action=addClase`, data, {
        headers: { "Content-Type": "application/json" },
      });

      if (res.data.success) {
        Swal.fire({
          confirmButtonColor: "#2E8B57",
          title: "Éxito!",
          text: "Nueva clase registrada correctamente.",
          timer: 5000,
          icon: "success",
        });

        // Actualizar el horario local sin volver a hacer fetch
        const nuevoHorario = { ...horario };
        if (!nuevoHorario[anioSeleccionado])
          nuevoHorario[anioSeleccionado] = {};
        if (!nuevoHorario[anioSeleccionado][diaParaAgregar])
          nuevoHorario[anioSeleccionado][diaParaAgregar] = [];

        nuevoHorario[anioSeleccionado][diaParaAgregar].push({
          hora: nuevoHora,
          materia: nuevaMateria,
        });

        setHorario(nuevoHorario);
        peticionGetHorario();
      } else {
        Swal.fire("Error", "No se pudo agregar la clase", "error");
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Error en la solicitud", "error");
    }

    setModal(false);
    setAgregandoClase(false);
  };
  const añosEstudio = [
    "PRIMER",
    "SEGUNDO",
    "TERCER",
    "CUARTO",
    "QUINTO",
    "SEXTO",
    "SEPTIMO",
    "OCTAVO",
    "NOVENO",
    "DECIMO",
  ];

  const DiasSemana = ["lunes", "martes", "miércoles", "jueves", "viernes"];
  return (
    <div id="main_content">
      <div className="tra">
        <div className="tra title-form">
          <h2>Horario</h2>
        </div>
        <Container fluid className="frm">
          {/* Selección de año */}
          <div className="mb-3">
            <h5>¿En qué año o semestre estás estudiando?</h5>
            <ButtonGroup>
              {añosEstudio.map((año) => (
                <Button
                  key={año}
                  color={anioSeleccionado === año ? "danger" : "secondary"}
                  onClick={() => handleAnioChange(año)}
                >
                  {`${año}`}
                </Button>
              ))}
            </ButtonGroup>
          </div>

          {/* Navegación por días */}
          <Navbar color="light" dark expand="md" className="title-form mb-3">
            <NavbarBrand>Seleccionar día:</NavbarBrand>
            <Nav className="ml-auto" navbar>
              {DiasSemana.map((dia) => (
                <NavItem key={dia}>
                  <NavLink
                    href="#"
                    active={diaSeleccionado === dia}
                    onClick={() => handleDiaChange(dia)}
                  >
                    {dia.charAt(0).toUpperCase() + dia.slice(1)}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
          </Navbar>

          {/* Tabla de clases */}
          <Table className="frm" responsive="sm" id="tabl">
            <thead id="stahead">
              <tr className="text-center">
                <th>Hora</th>
                <th>Materia</th>
                <th>Nota</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {horario.length > 0 ? (
                horario.map((clase, index) => (
                  <tr key={index}>
                    <td>{clase.hora}</td>
                    <td>{clase.materia}</td>
                    <td>{clase.nota}</td>
                    <td>
                      <Button
                        color="warning"
                        onClick={() => handleEditarClase(clase, index)}
                      >
                        Editar
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={3}>No hay clases en este horario</td>
                </tr>
              )}
            </tbody>
          </Table>

          {/* Botón para agregar clase */}
          <Button color="success" size="lg" onClick={handleAgregarClase}>
            Agregar Clase
          </Button>

          {/* Modal para editar o agregar clase */}
          <Modal isOpen={modal} toggle={() => setModal(false)}>
            <ModalHeader className="header_mo" toggle={() => setModal(false)}>
              {agregandoClase ? "Agregar Nueva Clase" : "Editar Clase"}
            </ModalHeader>
            <ModalBody>
              {/* Si es para agregar una nueva clase, selecciona el día */}
              {agregandoClase && (
                <FormGroup>
                  <Label for="dia">Día</Label>
                  <Input
                    type="select"
                    id="dia"
                    value={diaParaAgregar}
                    onChange={(e) => setDiaParaAgregar(e.target.value)}
                  >
                    {DiasSemana.map((dia) => (
                      <option key={dia} value={dia}>
                        {dia.charAt(0).toUpperCase() + dia.slice(1)}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              )}

              {/* Campo oculto para el ID de la clase */}
              {claseIdEditar && <Input type="hidden" value={claseIdEditar} />}

              {/* Campo para Hora */}
              <FormGroup>
                <Label for="hora">Hora</Label>
                <Input
                  type="text"
                  id="hora"
                  value={nuevoHora}
                  onChange={(e) => setNuevoHora(e.target.value)}
                  placeholder="Ejemplo: 14:00 - 15:30"
                />
              </FormGroup>

              {/* Campo para Materia */}
              <FormGroup>
                <Label for="materia">Materia</Label>
                <Input
                  type="text"
                  id="materia"
                  value={nuevaMateria}
                  onChange={(e) => setNuevaMateria(e.target.value)}
                  placeholder="Nombre de la materia"
                />
              </FormGroup>

              {/* Campo para Nota */}
              <FormGroup>
                <Label for="nota">Nota</Label>
                <Input
                  type="number"
                  id="nota"
                  value={nuevaNota}
                  onChange={(e) => setNuevaNota(e.target.value)}
                  placeholder="Nota de la materia"
                />
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              {agregandoClase ? (
                <Button
                  color="success"
                  size="lg"
                  onClick={handleGuardarNuevaClase}
                >
                  Guardar
                </Button>
              ) : (
                <Button color="success" size="lg" onClick={handleGuardarClase}>
                  Guardar Cambios
                </Button>
              )}
              <Button
                color="danger"
                size="lg"
                onClick={() => {
                  setModal(false);
                  setClaseIdEditar(null);
                }}
              >
                Cancelar
              </Button>
            </ModalFooter>
          </Modal>
        </Container>
      </div>
    </div>
  );
};

export default RegComp;
